export enum orderPaymentTypes {
  card = 5,
  balance = 2,
}
